module.exports = __webpack_public_path__ + "static/Audrey_Foncelle-a2cc2657cb288643fa02baf06337bd4a.webp";